import React from 'react';

import './StatusBadgeStyle.less';

export interface IStatusBadgeProps {
  status: 'approved' | 'credit' | 'denied' | 'partial' | 'pending' | 'repair';
}

const StatusBadge: React.SFC<IStatusBadgeProps> = (props: IStatusBadgeProps) => (
  <div className="status-badge">
    <div className={`badge-size status-${props.status}`}>{props.status.toUpperCase()}</div>
  </div>
);

export default StatusBadge;
